/**
 * Utility for normalizing URLs by replacing dynamic parameters with placeholders
 * Used for Application Insights telemetry aggregation
 */
export class UrlNormalizer {
  /**
   * Normalize URL by replacing ID parameters with placeholders
   * Examples:
   *   /shipments/116 -> /shipments/{id}
   *   /users/a1b2c3d4-e5f6-7890-1234-567890abcdef -> /users/{guid}
   *   /shipments/123/stops/456 -> /shipments/{id}/stops/{id}
   */
  static normalize(url: string): string {
    // Remove query params and hash
    let normalized = url.split('?')[0].split('#')[0];

    // Replace GUIDs (8-4-4-4-12 pattern) - must be before numeric IDs
    normalized = normalized.replace(
      /\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/g,
      '/{guid}'
    );

    // Replace numeric IDs (one or more digits between slashes or at end)
    normalized = normalized.replace(/\/\d+(?=\/|$)/g, '/{id}');

    return normalized;
  }
}
